import { mediaHelper, spacingHelper } from '@property.com.au/ui-kit';
import type { FunctionComponent } from 'react';
import styled from 'styled-components';
import { useSearchLandingPageBySlugQuery } from '../../graphql/useSearchLandingPageBySlugQuery';
import { VGDisclaimerFooter } from '../../../components/VGDisclaimerFooter/VGDisclaimerFooter';
import { useSearchLandingPageModalContext } from '../../contexts/SearchLandingPageModalContext/SearchLandingPageModalContext';
import { trackDisclaimerModalOpen } from '../../../analytics/event-tracking/trackDisclaimerModalOpen';

const Wrapper = styled.div`
  padding-bottom: ${spacingHelper('large')};

  ${mediaHelper('tabletMax')} {
    padding-left: ${spacingHelper('large')};
    padding-right: ${spacingHelper('large')};
  }

  > div {
    margin: 0 auto;
    max-width: 850px;
    width: 100%;
  }
`;

export const SearchLandingPageVGDisclaimerFooterWithData: FunctionComponent = () => {
  const data = useSearchLandingPageBySlugQuery();
  const { displayModal } = useSearchLandingPageModalContext();
  if (!data) return null;
  const { showDataDisclaimer } = data;
  return (
    showDataDisclaimer && (
      <Wrapper>
        <VGDisclaimerFooter
          onDisclaimerLinkClick={() => {
            displayModal('searchLandingPageVGDisclaimer');
            trackDisclaimerModalOpen({
              inPageSource: ['search_landing_page', 'footer_disclaimer', 'button'].join('__'),
            });
          }}
        />
      </Wrapper>
    )
  );
};
